import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    SCREENS = "screens",
    RESPIN_START = "respin_start",
    BLACK_OVERLAY_TOP = "black_overlay_top",
    WIN_COUNT_UP = "win_count_up",
    PARTICLES = "particles",
    WIN_WAYS = "win_ways",
    BIG_WIN = "big_win",
    ADDITIONAL_FS = "additional_fs",
    POSSIBLE_WAYS = "possible_ways",
    STICKY_S2 = "sticky_s2",
    SPLIT_ANIMATION = "split_animation",
    SYMBOL_COUNT = "symbol_count",
    M_TO_WILD = "m_to_wild",
    MULTIPLIER = "multiplier",
    ANTICIPATION = "anticipation",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    HIGH_SYMBOLS = "high_symbols",
    LOW_SYMBOLS = "low_symbols",
    REEL_BACKGROUND = "reel_background",
    LOGO = "logo",
    BLACK_OVERLAY_BOTTOM = "black_overlay_bottom",
    BACKGROUND = "background"
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize(): void {
        this.children.forEach((c: any) => {
            if (c.onResize) {
                c.onResize();
            }
        });
    }

    public onOrientationChanged(): void {
        this.children.forEach((c: any) => {
            if (c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        });
    }

    public addChild<T extends PIXI.DisplayObject>(...children: T[]): T {
        children.forEach((c: any) => {
            if (c.onResize) {
                c.onResize();
            }
            if (c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        })

        return super.addChild(...children);
    }
}

export class WalkOfShameLayers {

    constructor() {
        for (const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name: string): StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }
}
